import { useDispatch, useSelector } from "react-redux";
import {
  searched,
  tagRemoved,
  tagSelected,
  resetTag,
  setPageNo,
  setAuthor,
} from "../../features/filter/filterSlice";
import { fetchVideos } from "../../features/videos/videosSlice";

export default function Tag({ title }) {
  const dispatch = useDispatch();
  const {
    tags: selectedTags,
    search,
    pageNo,
  } = useSelector((state) => state.filter);

  const isSelected = selectedTags.includes(title) ? true : false;

  const style = isSelected
    ? "bg-blue-600 text-white px-4 py-1 rounded-full cursor-pointer"
    : "bg-blue-100 text-blue-600 px-4 py-1 rounded-full cursor-pointer";

  const handleSelect = () => {
    if (isSelected && selectedTags?.length > 1) {
      dispatch(searched(""));
      dispatch(tagRemoved(title));
    } else {
      dispatch(searched(""));
      dispatch(setPageNo(0));
      dispatch(setAuthor(""));
      dispatch(tagSelected(title));
    }

    if (title === "Reset") {
      dispatch(setAuthor(""));
      dispatch(resetTag([]));
      dispatch(searched(""));
      dispatch(setPageNo(1));
      dispatch(fetchVideos({ selectedTags, search, pageNo }));
    }

    // if (selectedTags?.length <= 0) {
    //   dispatch(setPageNo(1));
    // }
  };

  return (
    <div className={style} onClick={handleSelect}>
      {title}
    </div>
  );
}
